<template>
  <v-snackbar
    data-cy="my-snackbar"
    class="my-snackbar"
    v-model="snackState"
    :timeout="4000"
  >
    {{ message }}
  </v-snackbar>
</template>

<script>
export default {
  name: 'Snackbar',
  props: {
    showSnack: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: null
    }
    // timeout: {
    //   type: Number,
    //   default: null
    // }
  },
  computed: {
    snackState: {
      get () {
        return this.showSnack
      },
      set (val) {
        this.close()
      }
    }
  },
  methods: {
    close (e) {
      this.snackbar.commit('hide')
    }
  }
}
</script>

<style scoped lang="scss">
// @import '@/assets/style/dialog-warning.scss';
.v-snack.my-snackbar {
  height: var(--vh, 100%);
}
</style>
